import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/pages/PageHome.vue';
import Auth from '@/pages/AuthPage.vue';
// eslint-disable-next-line import/no-cycle
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/auth/:action',
    name: 'Auth',
    component: Auth,
    props: true,
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: '/thought/:id',
    name: 'Thought',
    component: Home,
    props: true,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../pages/PageDashboard.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/embed/:id/:search',
    name: 'embed',
    component: () => import(/* webpackChunkName: "dashboard" */ '@/components/embed/FrameBed.vue'),
  },
  {
    path: '/experiment',
    name: 'experiment',
    component: () => import(/* webpackChunkName: "dashboard" */ '../components/Glossary.vue'),
    // meta: {
    //   requiresAuth: true,
    // },
  },
  {
    path: '/canvas',
    name: 'canvas',
    component: () => import(/* webpackChunkName: "dashboard" */ '../pages/PageCanvas.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/Simplified-view',
    name: 'SimplifiedView',
    component: () => import(/* webpackChunkName: "firstView" */ '../pages/PageSimplifiedView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/Author-view',
    name: 'AuthorView',
    component: () => import(/* webpackChunkName: "firstView" */ '../pages/PageAuthorView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/Reading-view',
    name: 'ReadingView',
    component: () => import(/* webpackChunkName: "firstView" */ '../pages/PageReadingView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/mobile-view',
    name: 'MobileView',
    component: () => import(/* webpackChunkName: "firstView" */ '../pages/PageMobileView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/graph/:id',
    name: 'GraphPage',
    component: () => import(/* webpackChunkName: "graph" */ '../pages/PageGraph.vue'),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: '/VR',
    name: 'VR Dashboard',
    component: () => import(/* webpackChunkName: "vr" */ '../pages/PageVR.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/Settings',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "settings" */ '../pages/PageSettings.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/accessibility',
    name: 'Accessibility',
    component: () => import(/* webpackChunkName: "Accesibility" */ '../pages/PageAccesibility.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/privacyPolicy',
    name: 'Privacy Policy',
    component: () => import(/* webpackChunkName: "privacyPolicy" */ '../pages/PrivacyPolicy.vue'),
  },
  {
    path: '/termsOfUse',
    name: 'Terms Of Use',
    component: () => import(/* webpackChunkName: "termsOfUse" */ '../pages/TermsOfUse.vue'),
  },
  {
    path: '/logout',
    name: 'SignOut',
    meta: {
      requiresAuth: true,
    },
    beforeEnter(to, from, next) {
      store.dispatch('auth/logout').then(() => next({
        name: 'Home',
      }));
    },
  },
  {
    path: '/note/:id',
    name: 'note_page',
    component: () => import(/* webpackChunkName: "privacyPolicy" */ '../pages/NotePage.vue'),
    meta: {
      requiresAuth: true,
    },
    async beforeEnter(to, from, next) {
      // params id
      // console.log(to.params.id);
      await store.dispatch('getNote', to.params.id);
      next();
    },
  },
  {
    path: '/tag/:name',
    name: 'tag_page',
    meta: {
      requiresAuth: true,
    },
    async beforeEnter(to, from, next) {
      // params id
      // console.log(to.params.id);
      await store.dispatch('fetchTagContent', to.params.name);
      next();
    },
    component: () => import(/* webpackChunkName: "privacyPolicy" */ '../pages/TagPage.vue'),
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "notFound" */ '../pages/PageNotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // protected route
  store.dispatch('setRouteDetail', to.name);
  if (to.name !== 'embed') {
    store.dispatch('auth/initAuthentication').then((user) => {
      if (to.matched.some((route) => route.meta.requiresAuth)) {
        if (user) {
          next();
        } else {
          next({
            name: 'Auth',
            params: 'login',
            query: {
              redirectTo: to.path,
            },
          });
        }
      } else if (to.matched.some((route) => route.meta.requiresGuest)) {
        if (!user) {
          next();
        } else {
          next({
            name: 'Home',
          });
        }
      } else {
        next();
      }
    }).catch((err) => {
      throw err;
    });
  } else {
    next();
  }
});

export default router;
